import Client from '../../websocket';
import { Request1 } from './request1';
import { Loggy } from '../../loggy';
import { Registry } from './registry';

export default class RPC {
    client: Client;

    reqs: any;

    registries: { [name: string]: Registry };

    log: Loggy;

    constructor(client: Client) {
        this.client = client;
        this.reqs = {};

        this.log = client.log;
        this.registries = {};
    }

    req1(): Request1 {
        let req = new Request1(this, this.log);
        this.reqs[req.uuid] = req;
        return req;
    }

    handleClose() {}

    registry(key: string): Registry {
        if (this.registries[key]) {
            return this.registries[key];
        } else {
            let reg = new Registry();
            this.registries[key] = reg;
            return reg;
        }
    }

    handleResponse(data: any) {
        if (data && data.uuid) {
            let req = this.reqs[data.uuid];
            if (req != null) {
                req.handleResponse(data.data);
            }
        }
    }

    handleRequest(data: any) {
        if (data && data.uuid && data.path) {
            let splits = data.path.split('.');
            if (splits.length >= 2) {
                let registry = this.registries[splits[0]];
                if (registry != null) {
                    let method = registry.search(splits.slice(1));
                    if (method != null) {
                        let args: any[] = [];
                        if (data.args) {
                            args = data.args;
                        }
                        method.func(...args);
                    } else {
                        // nothing found !!!
                    }
                } else {
                    this.log.error('unable to find registry', splits[0]);
                }
            }
        }
    }
}
